import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_VANTIVE_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_VANTIVE,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_VANTIVE_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_VANTIVE_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_VANTIVE_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  VANTIVE_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  VANTIVE_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_VANTIVE,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE,
  OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  EDIT,
  DELETE,
  QUANTITY,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  VALID_DATE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  FEEDBACK_SUBMITTED,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  VANTIVE_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  PRIVACY_NOTICE,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_VANTIVE,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
  FOOTER_CREDIT_CONTACT_CUSTOMER,
  FOOTER_CREDIT_EMAIL_BOLD,
  FOOTER_CREDIT_PHONE_BOLD,
  FOOTER_CREDIT_EXPEDITE_REQUEST
} from '@translations';
import Login from '@views/Login';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

//Landing Page Translations
translations[APP_TITLE] = 'Product Feedback Portal';
translations[LANDING_BRIEF] = "The Product Feedback Portal System is intended for submission of confidential information and feedback about Vantive's products.";
translations[LANDING_LANGUAGE_SELECTOR] = 'Select Language Preference';
translations[LANDING_COUNTRY_SELECTOR] = 'Please select Country of Event';
translations[LANDING_TERMS] = "I have read and agree to the Terms of Use and Privacy Statement for Product Feedback Portal.";
translations[LANDING_TERMS_ERROR] = 'You must read and agree with the contents of the Terms of Use, Privacy Statement and Product Feedback Portal System Supplemental Term of Use and Privacy Statement for the Product Feedback Portal System.';
translations[LANDING_CAPTCHA_ERROR] = 'Please verify that you are not a robot.';
translations[APP_DESCRIPTION] = 'The Product Feedback Portal System is intended for submission of information about products. If you have encountered any issue with a Vantive product, we encourage you to share the details of that event. All feedback is essential for us to fulfill our shared goals of continuous product improvement and product satisfaction.';
translations[LANDING_TERMS_I_HAVE_READ] = 'I have read the linked Privacy Notice for the Vantive Product Feedback Portal and understand Vantive Healthcare Corporation (“Vantive”) is seeking my consent to use, disclose and process my personal data for the purposes and as described within the Privacy Notice.  I hereby consent to:';
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = 'The use, disclosure, storage and processing of my personal data (including any sensitive data, such as health-related data, that I choose to provide) for the purposes outlined in the Privacy Notice.';
translations[LANDING_TERMS_THE_TRANSFER_OF] = 'The transfer of my personal data (including sensitive data, such as health-related data, that I choose to provide) out of my country and to another country which may have less strict or no data protection laws.';
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = 'I understand that this consent is voluntary and that I may change my mind at any time and revoke my consent by contacting Vantive using the contact details provided in the Privacy Notice. I understand that withdrawing my consent will not affect the lawfulness of processing before its withdrawal.';

//Menu Translations
translations[MENU_FEEDBACK_FORM] = 'Initiate Product Feedback';
translations[MENU_FEEDBACK_STATUS] = 'Check Product Feedback Status';
translations[MENU_FORM_INTAKE] = 'Reporter / Contact Information';
translations[MENU_FORM_EVENT_DETAILS] = 'Event Details';
translations[MENU_FORM_PRODUCT_INFO] = 'Product Information';

//System Menu Translations
translations[SYSTEM_FEEDBACK_FORM] = 'Initiate Product Feedback Form';
translations[SYSTEM_FEEDBACK_STATUS] = 'Check Product Feedback Status';
translations[SUBMIT_FEEDBACK] = 'Click here to submit feedback.';
translations[CHECK_SUBMITTED_FEEDBACK] = 'Click here to check previously submitted feedback status.';
translations[BTN_LAUNCH_FORM] = 'LAUNCH FORM';
translations[BTN_CHECK_STATUS] = 'CHECK STATUS';

//Form Translations
translations[FORM_TITLE] = 'Product Feedback Form';
translations[FORM_SUB_TITLE] = 'If there are multiple patients involved, please fill out a form for each patient.';
translations[FORM_MANDATORY_FIELDS] = 'All fields with * are required';

//Button Translations
translations[BUTTON_PREV] = 'Previous';
translations[BUTTON_NEXT] = 'Next';
translations[BUTTON_SUBMIT] = 'Submit';

//Miscellaneous
translations[SELECT_RESPONSE] = 'Select response';

//Form Intake Translations
translations[FUNCTION_ROLE] = 'Function/Role';
translations[CUSTOMER_ACCOUNT_NUMBER] = 'Customer Account Number';
translations[ENTER_CUSTOMER_ACCOUNT] = 'Enter Customer Account';
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = 'What is the account number of the customer involved in the reported event?';
translations[EVENT_REPORTED] = 'Has this event been previously reported (to Vantive or any other entity)?';
translations[REFERENCE_NUMBER] = 'Reference number associated with this event';
translations[ENTER_REFERENCE] = 'Enter Reference';
translations[WHO_REPORTED_TO] = 'Who has this been reported to?';
translations[WHO_WAS_NOTIFIED] = 'Provide name of who was notified?';
translations[ENTER_NAME] = 'Enter Name';
translations[YOUR_NAME] = 'Your Name';
translations[OCCUPATION] = 'Occupation';
translations[PHONE_NUMBER] = 'Phone Number';
translations[ENTER_PHONE_NUMBER] = 'Enter Phone Number';
translations[ENTER_EMAIL] = 'Enter Email';
translations[EMAIL_ADDRESS] = 'Email Address';
translations[ENTER_ADDRESS] = 'Enter Email Address';
translations[ENTER_NA_IF_UNKNOWN] = 'Enter NA if unknown';
translations[FACILITY_HOSPITAL] = 'Facility/Hospital or Distributor Name (if applicable)';
translations[ENTER_FACILITY] = 'Enter Facility';
translations[ADDRESS_1] = 'Address 1';
translations[ADDRESS_2] = 'Address 2';
translations[CITY] = 'City';
translations[STATE] = 'State';
translations[POSTAL_CODE] = 'Postal Code';
translations[COUNTRY] = 'Country';
translations[END_USER_CUSTOMER] = 'Was this issue discovered by an end user/customer?';
translations[ADDITIONAL_CONTACT_PERSON] = 'Additional Contact Person';
translations[ADDITIONAL_PHONE] = 'Additional Contact Phone Number';
translations[ADDITIONAL_EMAIL] = 'Additional Contact Email';
translations[ANOTHER_FACILITY_ADDRESS] = 'Add another facility/address';
translations[ANOTHER_FACILITY_HOSPITAL] = 'Another Facility/Hospital or Distributor Name (if applicable)';
translations[ANOTHER_ENTER_FACILITY] = 'Enter Facility';
translations[ANOTHER_ADDRESS_1] = 'Address 1';
translations[ANOTHER_ADDRESS_2] = 'Address 2';
translations[ANOTHER_CITY] = 'City';
translations[ANOTHER_STATE] = 'State';
translations[ANOTHER_POSTAL_CODE] = 'Postal Code';
translations[ANOTHER_COUNTRY] = 'Country';

//Form Product Information Translations
translations[LOT_SERIAL_NUMBER] = 'Lot Number / Serial Number';
translations[ENTER_LOT_SERIAL_NUMBER] = 'Enter Lot Number / Serial Number';
translations[HELP_LOT_SERIAL_NUMBER] = 'Select Unknown if you do not know the Lot / Serial number, or if you asked the reporter and they did not know.';
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = 'Product Code';
translations[PRODUCT_CODE] = 'Product Code';
translations[ENTER_PRODUCT_CODE] = 'Enter Product Code';
translations[HELP_PRODUCT_CODE] = 'Select Unknown if you do not know the Product Code, or if you asked the reporter and they did not know.';
translations[NDC] = 'National Drug Code (NDC) Number';
translations[ENTER_NDC] = 'Enter NDC';
translations[UDI] = 'Unique Device Identifier (UDI)';
translations[ENTER_UDI] = 'Enter UDI';
translations[PRODUCT_NAME] = 'Product Name';
translations[ENTER_PRODUCT_NAME] = 'Enter Product Name';
translations[HELP_PRODUCT_NAME] = 'Provide the name or description of the product';
translations[BEST_DESCRIBES] = 'Please make selection that best describes the reported problem';
translations[QUANTITY_TO_SELECT] = 'Quantity To Select';
translations[ENTER_QUANTITY] = 'Enter Quantity';
translations[HELP_QUANTITY] = 'Number of product with the reported problem';
translations[UNIT] = 'Unit';
translations[AVAILABLE_TO_RETURNED] = 'Is the actual product with the reported problem available to be returned to Vantive for evaluation?';
translations[PHOTOGRAPH_AVAILABLE] = 'Is a photograph or video of the product available?';
translations[HELP_PHOTOGRAPH_AVAILABLE] = 'Ensure that the reported problem is visible in the photo or video.';
translations[UPLOAD_IMAGES] = 'Upload Images';
translations[REPORTER_NAME] = 'Reporter Name';
translations[REPORTER_FACILITY] = 'Reporter Facility';
translations[REPORTER_OCCUPATION] = 'Reporter Occupation';
translations[ENTER_NUMBER] = 'Enter number';
translations[REPORTER_PHONE_NUMBER] = 'Reporter Phone Number';
translations[REPORTER_EMAIL_ADDRESS] = 'Reporter Email Address';
translations[EMPLOYEE_NAME] = 'Employee Name';
translations[EMPLOYEE_PHONE_NUMBER] = 'Employee Phone Number';
translations[EMPLOYEE_EMAIL_ADDRESS] = 'Employee Email Address';
translations[RETURNING_FOR_INVESTIGATION] = 'How many samples (in units) with the reported problem are you returning for investigation?';
translations[HELP_RETURNING_FOR_INVESTIGATION] = 'These samples should be product with the reported problem.';
translations[UNUSED_VANTIVE_PRODUCT] = 'Is there ONE unused Vantive Product from the same lot available to be returned to Vantive for evaluation?';
translations[YOU_INDICATED_SAMPLES] = 'You indicated samples were available for evaluation, are you able to bring these to your healthcare provider?';
translations[SAMPLE_RETURN_KIT] = 'You indicated samples were available for evaluation, please confirm the address provided to send the sample return kit:';
translations[A_BOX_WITH_A_PREPAID_LABEL] = 'A box with a prepaid label will be sent to this address to return the sample';
translations[SAME_AS_MY_ADDRESS] = 'Same as My Address';
translations[OTHER_CONTACT_NAME] = "Other Contact's Name";
translations[OTHER_CONTACT_OCCUPATION] = "Other Contact's Occupation";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Other Contact's Phone Number";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "Other Contact's Email Address";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "The Product you selected is manufactured by another company, can we provide your contact information to them if they have additional questions about your report?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "Did the customer explicitly request investigation results?";
translations[EXPLICITLY_REQUEST_CREDIT] = "Did the customer explicitly request credit?";

//Content for Credit field footer question 
translations[FOOTER_CREDIT_CONTACT_CUSTOMER] =  "\nPlease contact Customer Care if you would like to request a credit: \n \n";
translations[FOOTER_CREDIT_EMAIL_BOLD] =  "Email: Can.hospitalcare@vantive.com ";
translations[FOOTER_CREDIT_PHONE_BOLD] =  "Phone: 1‑866‑968‑7477 \n \n";
translations[FOOTER_CREDIT_EXPEDITE_REQUEST] =  "To help expedite the request, please have your reference number available. Customer Care will assist you with the remaining steps required to process the request.";


translations[PRODUCT_FROM_VANTIVE] = "Does the customer order the product direct from Vantive?";
translations[QUANTITY_REQUESTED_CREDIT] = "Lot number(s) and quantity being requested for credit:";
translations[ENTER_OCCUPATION] = "Enter Occupation";
translations[LOT_QUANTITY_NUMBER] = "Enter Lot Number and quantity";
translations[WHOLESALERS_NAME] = "What is the wholesaler’s name and location (city, state)";
translations[PLACE_WHOLESALERS_NAME] = "Wholesaler’s name and location (city, state)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Add Product to the Grid";
translations[SAVE] = "Save";
translations[CANCEL] = "Cancel";
translations[ADD_MORE_PRODUCTS] = "Add More Products";
translations[REPORTER_ADDRESS] = "Reporter Address";
translations[ATTACHMENTS] = "Attachments";

//Form Event Details Translations
translations[DATE_OF_EVENT] = "Date of Event";
translations[DATE_OF_EVENT_MSG] = "Date of event cannot be after Date Vantive Employee was first notified. Please enter a valid date.";
translations[HELP_DATE_OF_EVENT] = "If there are multiple known dates that the event occurred, please fill out a form for each date.";
translations[DATE_VANTIVE_EMPLOYEE] = "Date Vantive Employee was first notified";
translations[DURING_WHAT_PROCESS] = "During what process step(s) did the event occur?";
translations[WAS_THE_PATIENT] = "Was the patient connected (treatment ongoing) at the time of the event?";
translations[WERE_YOU_CONNECTED] = "Were you connected (treatment ongoing) at the time of the event?";
translations[PROVIDE_ANY_ADDITIONAL] = "Provide any additional details related to the event/issue";
translations[HELP_YOU_IDENTIFIED_MORE] = "You identified more than one product and problem, please clarify which products had which reported problems.";
translations[ENTER_DETAILS] = "Enter details";
translations[PROVIDE_ANY_ATTACHMENT] = "Provide any Attachment as applicable";
translations[WAS_NEGATIVE_MEDICAL] = "Was there any negative medical impact, symptom(s) or injury as the result of the event?";
translations[WAS_MEDICAL_INTERVENTION] = "Was treatment, medical intervention or escalation of care provided to counteract the reported event?";
translations[PROVIDE_DETAILS] = "Provide Details";
translations[REQUIRED_TREATMENT] = "Required treatment/medical intervention";
translations[ENTER_TREATMENT] = "Enter treatment";
translations[RELEVANT_TESTS] = "Relevant tests including laboratory data:";
translations[HELP_RELEVANT_TESTS] = "Enter relevant tests";
translations[RELEVANT_MEDICAL_HISTORY] = "Relevant medical history including pre-existing medical conditions:";
translations[ENTER_HISTORY] = "Enter history";
translations[PATIENT_NAME] = "Patient's Name";
translations[PATIENT_INITIALS] = "Patient's initials or full name. If there are multiple patients involved, please fill out a form for each patient.";
translations[PATIENT_PHONE_NUMBER] = "Patient Phone Number";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "I do not wish to provide";
translations[PATIENT_EMAIL_ADDRESS] = "Patient Email Address";
translations[PATIENT_ADDRESS] = "Patient Address";
translations[SAME_ADDRESS] = "Same Address";
translations[DRUG_BEING_USED] = "Was a Vantive drug being used at the time of the event?";
translations[PATIENT_IDENTIFIER] = "Patient Identifier";
translations[PATIENT_AGE_OR_DOB] = "Patient Age or DOB";
translations[ENTER_PATIENT_AGE] = "mm/dd/yyyy, Enter Patient Age";
translations[PATIENT_GENDER] = "Patient Gender";
translations[PATIENT_WEIGHT] = "Patient Weight";
translations[ENTER_WEIGHT] = "Enter weight";
translations[PATIENT_WEIGHT_UNIT] = "Patient Weight Unit";
translations[MY_NAME] = "My Name";
translations[ENTER_IN_YOUR_CONTACT] = "Enter in your contact information";
translations[MY_PHONE_NUMBER] = "My Phone Number";
translations[MY_EMAIL_ADDRESS] = "My E-mail Address";
translations[MY_ADDRESS] = "My Address";
translations[NAME_OF_VANTIVE_DRUG] = "Name of Vantive Drug";
translations[ENTER_DRUG_NAME] = "Enter Drug name";
translations[PLEASE_PROVIDE_THE_NAME] = "Please provide the name or product code of the Vantive Drug.Provide the name of all Vantive drugs being used at the time of the reported issue";
translations[SELECT_THE_COMPONENT] = "Select the component which had the issue";
translations[USE_THE_DIAGRAM] = "Use the diagram above (Figure 1) to determine the location of the damaged disposable.";
translations[TYPE_OF_DAMAGE] = "Please describe the type of damage";
translations[PLEASE_ENTER_VALUE] = "Please enter the value";
translations[WAS_THE_PRODUCT_KINKED] = "Was the product kinked, cracked, bent, cut, etc?";
translations[WERE_ANY_CLEANING] = "Were any cleaning solutions, solvents or disinfectants used on the Product?";
translations[WHAT_WAS_THE_DISINFECTANT] = "What was the disinfectant name/brand and how was it used?";
translations[NOTE_VANTIVE_LABELING] = "Vantive labeling states do not apply bleach, hydrogen peroxide, alcohol or antiseptic containing alcohol to the set. Using these products can cause the product to develop cracks.";
translations[SELECT_ALL_THAT_APPLY] = "Select all that apply";
translations[DID_FOLLOWING_OCCUR] = "Did any of the following occur?";
translations[SELECT_THE_LOCATION] = "Select the location with the damage on the Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "Was the product exposed to any excessive force (i.e., banged, bumped, hit, knocked, etc,) before the problem occurred?";
translations[HOW_LONG_TRANSFER] = "How long has the transfer set been in use?";
translations[WAS_THERE_DIFFICULTY] = "Was there any difficulty when opening or closing the twist clamp?";
translations[WAS_DEVICE_OR_TOOL] = "Was a device or tool used to open or close the twist clamp?";
translations[DESCRIBE_HOW_PRODUCT] = "Describe how the product was difficult to use (Select all that apply)";
translations[DID_YOU_OBSERVE] = "Did you observe any damage (e.g. cut, hole, crack) with the product?";
translations[WERE_DIFFICULTIES_PUTTING] = "Were there any difficulties putting the Minicap on to the Transfer Set and twisting clockwise until firmly secured?";
translations[WAS_THE_TRANSFER] = "Was the transfer set replaced because of this event?";
translations[SELECT_TYPE_OF_FLOW] = "Select type of flow issue";
translations[WAS_ANYTHING_BLOCKING] = "Was there anything blocking the flow?";
translations[WAS_ANY_ALARM] = "Was there any alarm?";
translations[SELECT_BEST_DESCRIBE] = "Select option that best describe the issue";
translations[WERE_THE_MINICAPS] = "Were the Minicaps exposed or stored in a hot/cold environment?";
translations[WAS_THE_SPONGE_VISIBLE] = "Was the sponge visible inside the Minicap?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "Where is the particulate matter / foreign material located?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Describe the exact location, size, shape and color of the particulate matter / foreign material:";
translations[WAS_THE_PARTICULATE_MATTER] = "Was the particulate matter / foreign material embedded in the product?";
translations[DOES_THE_PARTICULATE_MATER] = "Does the particulate mater / foreign material appear to be pieces of the product material?";
translations[WHAT_COMPONENT_DOES] = "What component does the particulate appear to be from?";
translations[SELECT_CONNECTION_ISSUE] = "Select the option that best describes the connection issue";
translations[WERE_ASSIST_DEVICES] = "Were any assist devices or tools used to make the disposable connection?";
translations[WERE_ANY_DIFFICULTIES] = "Were any difficulties during initial connection noticed or disconnection?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Provide the product information of the second product that was involved in the connection issue";
translations[WERE_THE_SPIKE_LUER] = "Were the spike/luer connectors rotated clockwise until they were firmly secured?";
translations[VANTIVE_LABELING_STATES] = "Vantive labeling states to ensure all disposable set connections are secure and fit before beginning therapy.";
translations[WERE_PETS_OR_ANIMALS] = "Were there any pets or animals that could have damaged to the disposable set?";
translations[VANTIVE_LABELING_CONTAMINATION] = "Vantive labeling states contamination of the fluid pathways can result if a pet or animal bites the disposable supplies. To reduce this risk do not perform dialysis in the same room as pets or animals.";
translations[WERE_OTHER_ISSUES] = "Were there any other issues or difficulties associated with the spike/luer (i.e. cracked, deformed, bent etc)?";
translations[WAS_MINICAP_TWISTED] = "Was the Minicap twisted clockwise onto the transfer set connector until firmly secured?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Were there any difficulties putting the Minicap on to the Transfer Set?";
translations[DID_TRANSFER_SET_CONNECTORS] = "Did the transfer set connectors have any visible damage or residue on the threads?";
translations[WHAT_WAS_THE_ALARM] = "What was the alarm?";
translations[WHERE_OBSERVED_DAMAGE] = "Where was the observed damage (select all that apply)?";
translations[SELECT_THE_TYPE_OBSERVED] = "Select the type of the observed damage (select all that apply):";
translations[DID_DAMAGE_CAUSE_LEAK] = "Did the damage cause a leak?";
translations[WAS_THE_SHIPPING_CARTON] = "Was the shipping carton opened with a sharp object?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Select type of flow issue observed";
translations[HOW_LONG_WAS_STORAGE] = "How long was it in storage before the expired product was found?";
translations[WAS_THERE_AN_ADAPTER] = "Was there an adapter, or any other device(s), used with the product?";
translations[NAME_AND_MODEL] = "What is the name and model of the adapter or any other device used?";
translations[NAME_VAPORIZER] = "What is the name and model of the Vaporizer?";
translations[WAS_VIAL_INVERTED] = "Was the attached vial inverted prior to squeezing solution into the vial?";
translations[WHAT_VIAL_USED] = "What is the product information for the vial used?";
translations[DRUG_NAME_MANUFACTURER] = "Drug name, manufacturer, vial size";
translations[WERE_BREAK_FRANGIBLE] = "Were you able to break the frangible properly using a back and forth motion?";
translations[WAS_ALARM_ASSOCIATED] = "Was there any alarm associated with the no flow?";
translations[WHAT_PART_DISCOLORED] = "What part of the product was reported to be discolored? (select all that apply)";
translations[DESCRIBE_DISCOLORATION] = "Describe the discoloration (describe color, hue, tint, shade, etc):";
translations[HOW_PRODUCT_STORED] = "How was the product stored?";
translations[DOES_DISCOLORATION_APPEAR] = "Does the discoloration appear to be opaque, hazy, cloudy and/or has circular/honey-comb markings?";
translations[WHICH_CHAMBER_DISCOLORED] = "Which chamber was discolored on the bag?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "Was the peel seal or inter-chamber frangible already broken/activated?";
translations[WAS_DISCOLORATION_NOTICED] = "Was the discoloration noticed through the vaporizer sight glass?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Select option that more specifically describes the issue:";
translations[WHAT_DEVICE_HAD_ALARM] = "What device had the alarm?";
translations[WHAT_MISSING_MISASSEMBLED] = "What component was missing or misassembled?";
translations[RECONSTITUTION_ISSUE] = "Provide more specific description of the Reconstitution issue";
translations[WHAT_MEDICATION_SOLUTION] = "What medication/solution was the product being reconstituted with?";
translations[WHAT_VOLUME_MEDICATION] = "What was the volume of medication/solution used to reconstitute?";
translations[WHAT_DEVICES_RECONSTITUTION] = "What other devices were used during reconstitution (name/manufacturer, needle size/gauge, etc.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "Was the product exposed to heat?";
translations[DESCRIBE_EXPOSURE] = "Describe exposure (temperature, for how long, etc.)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "What technique was used to activate the solution?";
translations[WAS_DAMAGE_OBSERVED] = "Was there any damage observed to the product prior to activation?";
translations[DESCRIBE_THE_DAMAGE] = "Describe the damage:";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Approximately, how much solution or powder was under-filled or over-filled?";
translations[WAS_LEAK_OBSERVED] = "Was there any leak observed?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "What component or feature of the product is difficult to use?";
translations[HOW_WAS_DIFFICULT_USE] = "How was the product difficult to use?";
translations[WHERE_MATTER_FOREIGN] = "Where was the particulate matter/foreign material located?";
translations[DOES_PARTICULATE_MATTER] = "Does the particulate matter/foreign material appear to be pieces of product material?";
translations[DESCRIBE_EXACT_LOCATION] = "Describe the exact location, color, size, shape and texture of the particulate matter/foreign material:";
translations[WAS_MATTER_FOREIGN] = "Was the particulate matter/foreign material embedded in the product (not freely moving)?";
translations[WHEN_MATTER_FOREIGN] = "When was the particulate matter/foreign material observed?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Provide product information for the medication added:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Product name, product code, product lot number, Brand Name";
translations[DESCRIBE_SPIKING] = "Describe spiking or reconstitution technique that was used:";
translations[INCLUDE_NEEDLE] = "Include needle size/gauge, angle of spiking/piercing, number of attempts";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "What administration set or reconstitution device was used?";
translations[INCLUDE_MANUFACTURER] = "Include Manufacturer, product name, product code, product lot";
translations[WAS_MEDICATION_ADDITIVE] = "Was a medication, additive, or reconstitution solution added to the product?";
translations[WHAT_MEDICATION_ADDITIVE] = "What medication, additive, or reconstitution solution was added?";
translations[WHAT_STATE_OF_PRODUCT] = "What was the state of the product when the cloudiness/precipitate was observed?";
translations[AFTER_UNITS_SAT] = "After the units sat out and reached room temperature, did the cloudiness/precipitate go away?";
translations[DID_ATTEMPT_AGITATE] = "Did you attempt to agitate the unit?";
translations[DID_PRECIPITATE_DISSOLVE] = "Did the precipitate dissolve?";
translations[WHAT_STORAGE_TEMPERATURE] = "What were the product storage temperature and conditions?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Provide temperature, location, stored inside or outside the overpouch/carton, In VSC/Intermediate Carton, Individual Units";
translations[ARE_TEMPERATURE_LOGS] = "Are temperature logs for the freezer(s) that the product is stored in available?";
translations[LOGS_CAN_BE_ATTACHED] = "Logs can be attached directly to this form, if available at time of submission";
translations[IS_THE_STORAGE_UNIT] = "Is the storage unit (freezer or refrigerator) calibrated and temperature controlled?";
translations[HOW_PRODUCT_THAWED] = "How was the product thawed?";
translations[WHAT_STORAGE_CONDITIONS] = "What were the storage conditions of the product? (temperature, location, stored inside or outside the overpouch/carton)";
translations[WAS_ANY_DAMAGE] = "Was there any damage to the product or issue observed?";
translations[MORE_SPECIFIC_INFORMATION] = "Please provide more specific information:";
translations[WHAT_PURPOSE_INDICATION] = "What was the purpose/indication of treatment for the patient?";
translations[WHAT_ROUTE_ADMINISTRATION] = "What was the route of administration?";
translations[WHAT_DATE_ADMINISTRATION] = "What was the date of administration and duration?";
translations[WHAT_DOSAGE_STRENGTH] = "What was the dosage/strength administered to the patient?";
translations[WAS_RECENT_PRESCRIPTION] = "Was there a recent prescription change?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "What was the storage/temperature details of the product (location of storage/refrigerator/freezer, etc)?";
translations[WERE_ANY_ADJUSTMENTS] = "Were there any adjustments to the solution or additives prior to administration?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Select the most appropriate description of the issue:";
translations[SELECT_LABELING_ISSUE] = "Select the most appropriate description of the labeling issue:";
translations[WAS_CONNECTION_SECURE] = "Was the connection secure and fully tightened?";
translations[WAS_EXPIRED_PRODUCT] = "Was the expired product administered to a patient?";
translations[WAS_COMPONENT_DAMAGED] = "Was there any component damaged?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Were there any abnormalities/damage noticed to the product?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "What is your purchase order number?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "What was the date of administration?";
translations[WHAT_WAS_EXPIRATION_DATE] = "What was the expiration date on the product?";
translations[DESCRIBE_WAS_INCORRECT] = "Describe what was incorrect, incomplete, missing, illegible on the label or what was too similar (to another product) on the label:";
translations[WHAT_SCANNER_USED] = "What type of scanner was used?";
translations[WAS_OVERPOUCH_POUCH] = "Was the product still in the overpouch/pouch while scanning?";
translations[WHAT_BACKGROUND_COLOR] = "What was the background color when scanning?";
translations[DO_ALL_OF_THE_LABELS] = "Do all of the labels (product, box/carton, shipping/distribution) have the same product information?";
translations[PRODUCT_INFORMATION] = "Product Information:";
translations[IS_A_BARCODE_SCANNER] = "Is a barcode scanner used at your facility?";
translations[HOW_ARE_THESE_PRODUCTS] = "How are these products stored in the facility?";
translations[WHAT_INFORMATION_INCORRECTLY] = "What information was incorrectly displayed when scanned?";
translations[WAS_THERE_LEAK] = "Was there a leak or moisture observed?";
translations[WHERE_LEAK_OBSERVED] = "Where was the leak observed, what component was leaking?";
translations[WAS_FRANGIBLE_OBSERVED] = "Was the frangible observed broken?";
translations[IS_MOISTURE_CLEAR] = "Is the moisture clear?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Who is your Distributor?";
translations[WHAT_MANUFACTURER_MEDICATION] = "What is the manufacturer, medication name, and size of vial used?";
translations[WHAT_GAUGE_NEEDLE] = "What is the gauge of needle used, manufacturer, and number of times site was punctured?";
translations[WHAT_ADMINISTRATION_SET] = "What administration set was used?";
translations[WAS_DIFFICULTY_SPIKING] = "Was there difficulty spiking?";
translations[WERE_FOLLOWING_SCENARIOS] = "Were any of the following scenarios occurred with the leak?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "Was the frangible observed to have damage or a defect?";
translations[WHAT_AMOUNT_PRESSURE] = "What amount of pressure was applied and for what duration?";
translations[WAS_BAG_COMPLETELY] = "Was the bag completely and correctly inserted into the pressure cuff (was one end outside of the pressure cuff)?";
translations[WHAT_MANUFACTURER_MODEL] = "What is the manufacturer, model and size of the pressure cuff?";
translations[WHAT_PRESSURE_PRIOR] = "What was the pressure prior to the leak being detected?";
translations[LIST_THE_VAPORIZER] = "List the vaporizer manufacturer and name/model";
translations[APPROXIMATELY_HOW_MUCH] = "Approximately how much liquid was spilled?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "Was the bottle difficult to insert into the vaporizer?";
translations[WERE_VISIBLE_DEFECTS] = "Were there any visible defects?";
translations[SELECT_THE_OPTION] = "Select the option that best describes the connection issue";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Provide the product information of the second product that was involved in the connection issue";
translations[WHICH_PART_SEPARATED] = "Which part(s) of the product separated?";
translations[WHAT_COMPONENT_DISCOLORED] = "What component is discolored?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Select option that best describes the discoloration:";
translations[WAS_THE_SET_DISCOLORED] = "Was the set discolored when it was removed from the package?";
translations[DID_SET_CHANGE_COLOR] = "Did the set change color after adding medication?";
translations[WHAT_MEDICATION_ADDED] = "What medication was added prior to the color change?";
translations[WHERE_MATERIAL_LOCATED] = "Where was the particulate matter / foreign material located?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Describe the particulate matter / foreign material (appearance / color / size):";
translations[WAS_EMBEDDED_PLASTIC] = "Was the particulate matter / foreign material loose or embedded in the plastic?";
translations[WAS_THERE_A_PRECIPITATE] = "Was there a precipitate or change in color of the infusate/solution that was not expected?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "What medications/solutions have been infused through the set?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Where was the damage or what component(s) was affected (select all that apply)?";
translations[WHAT_DAMAGE_ISSUE] = "What type of damage/issue was observed (select all that apply)?";
translations[DID_ISSUE_RESULT] = "Did this issue result in a leak?";
translations[WAS_PATIENT_CONNECTED] = "Was the patient connected to the product?";
translations[WAS_PRODUCT_REPLACED] = "Was the product replaced with a new product?";
translations[WHICH_SITUATION_BEST] = "Which situation best describes the Separation / Connection Issue";
translations[SELECT_MOST_LABELING_ISSUE] = "Select the most appropriate description of the labeling issue:";
translations[WHAT_INFORMATION_DISPLAYED] = "What information was displayed?";
translations[WHAT_SCANNER_WAS_USED] = "What type of scanner was used?";
translations[INCLUDE_THE_MODEL_NAME] = "Include the model name";
translations[WAS_PRODUCT_ORDERED] = "Was the product ordered directly from Vantive or another distributor?";
translations[WHERE_LEAK_COMING] = "Where is the leak coming from (select all that apply)?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "Did any of the following scenarios occurred with the leak?";
translations[WAS_POWER_INJECTOR] = "Was the product used with a power injector?";
translations[WHAT_INJECTOR_USED] = "What power injector was used?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Manufacturer, product name, product code, product lot";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Describe what was incorrect, incomplete, missing, illegible or changed on the label:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Provide the product information of the second product that was involved in disconnection";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Which components were found to have a crack or break?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Describe the exact location on the tubing that had the cut, hole, or slice:";
translations[WAS_LEAK_ORIGINATING] = "Was the leak originating from the injection site opening";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Provide the product information of the second product that was involved in disconnection/connection issue";
translations[WHICH_SPECIFIC_BONDED] = "Which specific bonded components were found to be separated?";
translations[WERE_VISIBLE_IRREGULARITIES] = "Were there any visible irregularities/damage on the product/components involved";
translations[WAS_SUCCESSFUL_CONNECTION] = "Was a successful connection or disconnection eventually established (without having to replace the product)?";
translations[WAS_TOOL_USED_ASSIST] = "Was a tool used to assist with the connection/disconnection?";
translations[WERE_LUER_CONNECTIONS] = "Were all Luer connections checked to ensure that they were secure prior to use (per label copy)";
translations[WAS_PRODUCT_SECURELY] = "Was the product securely connected with another product prior to disconnecting?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Which situation best describes the Flow Issue?";
translations[WHAT_FLOWING_BACKWARDS] = "What was flowing backwards?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Describe the components from where backflow started to where it stopped:";
translations[DO_SITUATIONS_APPLY] = "Do any of these situations apply to this event?";
translations[WHICH_SPECIFIC_AREA] = "Which specific area of the set or component was associated with the flow issues?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "Was flow previously seen through the set or component?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "Was any of the following observed:";
translations[WHERE_SIMULTANEOUS_FLOW] = "Where was the Simultaneous Flow between?";
translations[WHAT_TYPE_HANGER] = "What type of hanger was used?";
translations[WHAT_WAS_HANGER_LENGTH] = "What was the hanger length and/or manufacturer?";
translations[WHICH_BAG_LOWER] = "Which bag was lower?";
translations[WHAT_Y_SITE_WAS] = "What y-site was the secondary set connected to?";
translations[WHAT_COMPONENT_WITHIN] = "What component within the set is unable to be cleared of solution or blood?";
translations[WAS_COMPONENT_SET_REPLACED] = "Was the component/set replaced after it is unable to be cleared?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "What was the volume of fluid to be infused to the patient and the prescribed period of time?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "What was the volume of fluid actually infused in the patient over what time period?";
translations[WAS_USED_WITH_PUMP] = "Was the set used with a pump?";
translations[DID_CLAMP_FAIL] = "Did a clamp fail to stop or control flow?";
translations[WHAT_CLAMP_FAILED] = "What clamp failed?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Was there any issues observed with the clamp?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "Do any of these other situations describe the product issue (select all that apply)?";
translations[DESCRIBE_ALARM_OBSERVED] = "Describe the alarm observed:";
translations[INCLUDE_ANY_MESSAGES] = "Include any messages and error codes associated with the alarm";
translations[WHICH_CLAMP_HAD_ISSUE] = "Which clamp had the issue?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Which type of clamp issue was experienced (select all that apply)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Select the scenario that best describes the issue:";
translations[PROVIDE_MORE_DETAILS] = "Provide more details on how the product was difficult to use:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Provide more details on the instructions that were difficult to follow/understand:";
translations[DESCRIBE_THE_SMELL] = "Describe the smell and where it was coming from:";
translations[WAS_ISSUES_WITH_SET] = "Was there any issues observed with the set?";
translations[WHERE_LEAK_LOCATED] = "Where on the product was the leak located?";
translations[DID_OCCUR_WITH_LEAK] = "Did any of the following occur with the leak?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Provide the product information of the second product that was involved in disconnection";
translations[DID_OCCURRED_WITH_THE_LEAK] = "Did any of the following scenarios occurred with the leak?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Where was the product damaged?";
translations[SELECT_ALL_APPLY] = "Select all that apply";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Describe the observed damage";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "What component of the product was discolored?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Describe color observed (hue, tint, shade, etc.):";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "Inside or outside overpouch, temperature, exposure to light, etc.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Describe the exact location, size, shape and color of the particulate matter/foreign material:";
translations[DOES_THE_PARTICULATE_MATTER] = "Does the particulate matter / foreign material appear to be product material?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "Was the particulate matter / foreign material embedded?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "Does the particulate mater / foreign material appear to be pieces of the product material?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Where on the product did the issue occur?";
translations[LIST_COMPONENTS_IF] = "List components. If a second product was involved, provide Manufacturer, product name, product code, product lot";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Were there any visible irregularities/damages observed?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Select the option that best describes the flow issue";
translations[DESCRIBE_IRREGULARITIES] = "Describe irregularities/damage and if damage was observed prior to connection/disconnection or if occurred during the connection/disconnection";
translations[HOW_PRODUCT_SETUP] = "How was the product setup?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Select the most appropriate description of labeling issue:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Describe what was incorrect, incomplete, missing, illegible on the label or what was too similar (to another product) on the label:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "Was the product within the shipping carton damaged?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "What product was supposed to be received?";
translations[IF_PRODUCT_CODE_NOT] = "If product code not available, please provide product description";
translations[WAS_THE_CASE_MISSING] = "Was the case missing dry ice or refrigerated gel packs?";
translations[WHAT_CARRIER_DELIVERED] = "What carrier delivered your product?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "What is the purchase order number?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "What was the quantity of missing units?";
translations[WAS_EXPIRED_PRODUCT_USE] = "Was the expired product used?";
translations[APPLY_TO_EACH_UNIT] = "If this issue occurred in more than one unit, the questions below apply to each unit.";

//footer translations
translations[TERMS_CONDITIONS] = "Terms & Conditions";
translations[PRIVACY_POLICY] = "Privacy Policy";
translations[PRIVACY_NOTICE] = "Privacy Notice";
translations[COOKIE_POLICY] = "Cookie Policy";

//fildOptions translations
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Asked Unknown";
translations[OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE] = "Vantive Employee";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Caregiver";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Distributor";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Healthcare Professional";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Patient";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Other";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "After Use";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Before Use";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "During Setup/Preparation/Compounding";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "During Therapy";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Multiple Steps";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "Not Specified";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Family Member";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Nurse";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Nurse Practitioner";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Other Health Care Professional";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Physician";
translations[OPTION_UNITOPTIONS_BOXES] = "Boxes";
translations[OPTION_UNITOPTIONS_PALLETS] = "Pallets";
translations[OPTION_UNITOPTIONS_UNITS] = "Units";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Alarm Condition";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Damage";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Difficult To Use";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Discolored";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Flow Issues";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Labeling Issues";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Leak / Excessive Moisture";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Particulate Matter / Foreign Material";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Patient Reaction / Adverse Event";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Product Inquiry";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Separation / Connection";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Shipping Issues / Expired Product";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Female";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Undifferentiated";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Male";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Decline to answer";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Administrator/Supervisor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Biomedical Engineer";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Company Representative";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Dentist";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Distributor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Family Member";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Lay User";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Nurse";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Nurse Practitioner";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Other Health Care Professional";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Pharmacist";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Pharmacy Technician";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Physician";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Patient";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Risk Manager";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Other";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Contact Additional Contact Person";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Contact Me";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Contact Other";
translations[OPTION_REPORTEDTOOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "China FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Health Canada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Japan)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Australia)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "A pet or animal could have caused the problem";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "A sharp object or tool was used to open the carton or overpouch";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "The product was exposed to excessive force (i.e., banged, bumped, hit, etc.) before the problem occurred";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "The product was exposed or stored in a hot/cold environment";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Carton";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Minicap";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Pouch";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "The transfer set was too tight";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "The transfer set was too loose";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "The transfer set was unable to completely close";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "The transfer set was unable to completely open";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "The twist clamp was so tight that the transfer set was not able to open at all";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "The twist clamp was so tight that the transfer set was not able to close at all";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Yes - there was damage to/something wrong with the transfer set threads preventing it to close properly";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Yes - the Minicap was overtightened to the transfer set by hand or with a tool/assist device";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Completely stopped with no fluid flowing";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Restricted or Partially flowing (slow flow)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Clotted Blood";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Fibrin";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Kink";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Particulate";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Product Material";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Excess iodine (brown) identified upon connection or in the packaging";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Excess moisture (clear droplets) identified in the packaging";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Foil pouch damaged before opening";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Package/box open or damaged before use";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Sponge dried out and white";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Sponge dried out with a brownish color";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "In the secondary packaging/overpouch";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Inside the product/fluid path";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Inside the shipping carton";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "On the outside of the product";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "On the outside of the secondary packaging/overpouch";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "On the exterior of the shipping carton";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Difficulties connecting the product to another product";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Difficulties disconnecting the product from another product";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separation of components in a single product";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separation/disconnection of the product from another product";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "YES - residue on the threads";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "YES - visible damage";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Yes - Other (Free Text)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Hanger Hole";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Injection/Filling Port";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Membrane Port";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Overpouch/pouch";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Patch";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Rubber Stopper";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Shipping carton";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Shrinkband";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Solution container";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Tamper-evident seal(shrink wrap)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Bent";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Broken";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Cracked";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Cut";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Deformed";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Flaking";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Hole";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "Kinked";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Melted";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Patch Layer Separation";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Shattered (glass)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Sliced";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Torn";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "Solution would not flow at all";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "Solution would flow very slowly";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "Solution would not flow (or flow slowly) during reconstitution or compounding";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Bottle";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Container";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Hanger Hole";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Liner";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Overpouch/pouch";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Oxygen indicator";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Patch";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Ports";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Solution";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Amino Acid Chamber";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Dextrose Chamber";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Lipid Chamber";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Lower Chamber";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Upper Chamber";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Burst/Ruptured Seal";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Misassembled product/part";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Missing Component";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Separation/Disconnection of Bonded Component(s)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "Product Over filled";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Product Under filled";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Reconstitution Issue";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "In the secondary packaging/overpouch";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "Inside the shipping carton";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "On the exterior of the shipping carton";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Inside solution/fluid path";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "Inside the vaporizer sump (sight glass)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "On external surface of product";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "On the outside of the secondary packaging/overpouch";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "On the Oxygen absorber";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "On the Transdermal patch";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Glass Particles";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Port";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Rubber stopper";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Tubing";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "After adding another medication or after reconstitution (vials)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Prior to spiking or reconstitution";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "Cold (thawed but not yet room temperature)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Frozen";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Partially thawed (ice crystals in solution)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Room temperature";
translations[OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING] = "Vantive Thawing Unit (VTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "Left on counter at room temperature";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Refrigerator";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Yes - there was evidence of damage during shipping";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Yes - there was a leak observed";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "Yes - there was a hole or incomplete seal in the overpouch";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "Yes - there was difficulty spiking or reconstitution";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "Yes - there was difficulty breaking the frangible";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "Yes - there was crystallization or precipitation of solution";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "Yes - there was cloudiness/precipitate in Frozen Galaxy product";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "Product did not provide intended effect or was ineffective (lack of effect)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Unintended effect / reaction. Please Specify: (free text)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Damaged shipping carton during delivery";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Expired Product delivered";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "Expired Product found";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barcode Issue - Incorrect Information displayed when scanned";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficulties scanning/unscannable Barcode";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Expired Product delivered";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Expired Product found in inventory";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Illegible Label";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Incorrect label";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Incomplete Label";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "Label too similar to another product";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Labels (product, box/carton, shipping list) do not have the same product information";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Missing Barcode";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "Carton/box contains wrong product or mixed product";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Damaged shipping carton during delivery";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Extra units were received";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Expired Product delivered";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Expired Product found";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Part of the carton was opened or not sealed";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Product information on the carton and distribution label did not match the product inside the carton";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Units were missing";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Missing Label";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Expiration Date";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Lot Number";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "NDC Number";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "Droplets/moisture inside overpouch with no leak observed";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Leak";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Leak observed when the bag is squeezed";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Solution flowing past the frangible";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "Solution inside overpouch with no leak observed";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Between overpouch and primary container";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "Connection between two products";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Container - Membrane Port/Tube";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Container - Injection/Filling Port";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Container - Hanger Hole";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Container";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Rubber Stopper";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Shrinkband";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Vial Adapter";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Damage (holes, tears) to the secondary packaging or intermediate carton";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Exposure to extreme hot/cold";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Leak at vaporizer interface";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "Opening shipping carton with a box cutter/sharp object";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Pets (clawed/chewed)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Solution bag under pressure with a pressure cuff or other device";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Damage (holes, tears) to the secondary packaging or intermediate carton";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Damaged shipping carton during delivery";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Exposure to extreme hot/cold";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Leak at vaporizer interface";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Opening shipping carton with a box cutter/sharp object";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Pets (clawed/chewed)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Solution bag under pressure with a pressure cuff or other device";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "None of the above";
translations[NO_DESCRIBE_THE_COLOR] = "No - describe the color (free text)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "Greater than 10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Less than 1mL";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Bottle";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Cap";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "Valve/neck";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "None";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Difficulties connecting the product to another product";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Difficulties disconnecting the product from another product";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separation of components in a single product";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separation/disconnection of the product from another product";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Drip Chamber";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Tubing";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Other - Please specify (Free text)";
translations[OTHER_PLEASE_SPECIFY] = "Other - Please specify (Free text)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "White/Cloudy";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Yellow/Brownish";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "Other - Please specify (Free text)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "In the primary packaging/blister pouch";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "Inside the IV fluid path (in the tubing)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Inside the shipping carton";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "On the exterior of the shipping carton";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "Outside the IV Fluid path (exterior of the tubing)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Embedded";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Loose";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "Not applicable";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "Describe color (free text)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Yes - Change in Color";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Yes - Precipitate";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Access Site";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "Burrettes";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Clamp";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Drip Chamber";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Tubing";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Unknown";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Filters";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Luer Connector";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Spike";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Cut/Cracked/Broken Component(s)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Incorrect Component Assembly - Please specify (free text)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Kinked/Collapsed Component(s)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Loose Component(s) Inside Packaging";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Malformed/Mis-shaped Component(s)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Missing Component";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "Difficulty connecting the product to another product";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "Difficulty disconnecting the product from another product";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "Loose connection";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separation/disconnection of the product from another product";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Separation between two bonded components in a single product";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "Unable to connect two products together";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "Unable to disconnect the product from another product";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barcode Issue - Incorrect Information displayed when scanned";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Change in Labeling";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficulties scanning/unscannable Barcode";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Expired Product";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Incorrect Information on Label";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Missing Barcode/UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Missing Information on Label";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Product with no Expiration";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Smudges / Illegible Labeling";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "Carton/box contains wrong product or mixed product";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Damaged shipping carton during delivery";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Expired Product delivered";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Expired Product found";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR] = "Distributor";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Extra units were received";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Part of the carton was opened or not sealed";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Product information on the carton and distribution label did not match the product inside the carton";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "Units were missing";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Access Site";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Air vent";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Burettes";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Cap";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Clearlink injection sites";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Clamp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Drip Chamber";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filters";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Interlink injection sites";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Luer connector";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Spike";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Tubing";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Leak between the injection site and tubing";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Needle-Based Injection Site";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "One-Link injection sites";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Other injection sites (Free Text)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "Crack/break in rigid set components";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "Cut/slice in the soft tubing";
translations[DISCONNECTION_OF_CONNECTABLE] = "Disconnection of connectable components/connected products";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Disconnection of connectable components/connected products";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Separation of bonded components";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Yes - Describe irregularities/damage (free text)";
translations[YES_SPECIFY_THE_TOOL] = "Yes - Specify the tool used (Free Text)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Backflow";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Clamp Failure - Difficult to Clamp (but able to close eventually)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Clamp Failure - Unable to close off entirely";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Clamp Failure - Difficult/Unable to Open";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "No Flow";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Over Infusion";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Restricted/Slow Flow";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Simultaneous Flow";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Unable to clear component";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Unable to Prime";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Under Infusion";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Patient's blood (not blood products being infused)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Solutions/Blood Products";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Leak Damage/Hole";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Disconnection";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Leak";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "Medication was being given via pressurized infusion syringe, or IV pump";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "Secondary bag was lower than the primary bag";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "Secondary bag was at the same height with primary bag";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Blood Clotting";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "Catheter was not able to be flushed prior to attaching the set";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Kinked Tubing";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Tubing/injection site blockage";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Primary and Secondary container (piggyback)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Two or more leads flowing in a multi-lead set";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "Two administration sets each with its own infusion pump";
translations[OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER] = "Vantive Hanger";
translations[OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER] = "Non-Vantive Hanger";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "Bags were at the same height";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Primary";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Secondary";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Middle";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "Lower";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Upper";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Yes - Provide name and product code of the pump (free text)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Dark Blue Slide Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Light Blue Slide Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Notch Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Roller Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "White Slide Clamp";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Yes - the clamp was broken or cracked";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "Air In Line";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Clamp Issue";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "Odor";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Notch/Pinch Clamp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Roller Clamp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Slide Clamp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "Cracked/Broken";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "Difficult to open";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "Difficult to close";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "Missing";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Unable to open";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "Unable to close";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "Unable to control flow";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "Difficult to squeeze drip chamber";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Instructions were difficult to follow/understand";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "Product was difficult to use";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Crack/break";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Cut/slice";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Disconnection of connectable components/connected products";
translations[DISCONNECTION_OF_CONNECTABLE] = "Disconnection of connectable components/connected products";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "Hole/tear";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Separation of bonded components";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Damage (holes, tears) to the secondary packaging or intermediate carton";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Damaged shipping carton during delivery";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Exposure to extreme hot/cold";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Opening shipping carton with a box cutter/sharp object";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "None of the above";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Pressure cuff or pressure injector used";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Pets (clawed/chewed)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Product";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "Shipping Carton/box";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "Inside the product";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Inside the shipping carton";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "On the outside of the product";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Difficulties connecting the product to another product";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Difficulties disconnecting the product from another product";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Loose connection";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separation of components in a single product";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separation/disconnection of the product from another product";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "On the exterior of the shipping carton";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "On the inside of secondary packaging/overpouch";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "On the outside of secondary packaging/overpouch";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Not Flowing";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "Restricted or Partially flowing";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barcode Issue - Incorrect Information displayed when scanned";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficulties scanning/unscannable Barcode";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Illegible Label";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Incorrect label";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Incomplete Label";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Labels (product, box/carton, shipping list) do not have the same product information";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Label too similar to another product";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Missing Label";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Missing Barcode";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "Frozen product was received";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "Thawed product was received";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Yes, Alarm not known";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Yes, Specify";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Yes - the transfer set was not able to be fully open";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Yes - the transfer set was not able to be fully closed";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "Yes - the twist clamp was so tight that the transfer set was not able to be open at all";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "Yes - the twist clamp was so tight that the transfer set was not able to be close at all";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Box or overpouch";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Blue Clamp on Last Fill Line";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Cassette";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Drain Line Connector and Pull Ring Cap";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Effluent Sample Site";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Lines";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Luer/Spike Connectors";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Organizer";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Pull Ring Caps/Tip Protector on the Patient Line";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Pull Ring Caps/Tip Protectors";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Red Clamp on Heater Line";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Tack Weld";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "White Clamp on Supply Line";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Beige Catheter Adapter Connector";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Chip Insert";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Dark Blue Connector";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Light Blue Main Body";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Light Blue Pull Ring Cap";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Light Blue Occluder Legs";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Silicone Tubing";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Titanium Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "UV Flash Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "White Twist Clamp/Sleeve";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Yes: Describe the damage (free text)";
translations[OPTION_MONTHOPTIONS_JAN] = "Jan";
translations[OPTION_MONTHOPTIONS_FEB] = "Feb";
translations[OPTION_MONTHOPTIONS_MAR] = "Mar";
translations[OPTION_MONTHOPTIONS_APR] = "Apr";
translations[OPTION_MONTHOPTIONS_MAY] = "May";
translations[OPTION_MONTHOPTIONS_JUN] = "Jun";
translations[OPTION_MONTHOPTIONS_JUL] = "Jul";
translations[OPTION_MONTHOPTIONS_AUG] = "Aug";
translations[OPTION_MONTHOPTIONS_SEP] = "Sep";
translations[OPTION_MONTHOPTIONS_OCT] = "Oct";
translations[OPTION_MONTHOPTIONS_NOV] = "Nov";
translations[OPTION_MONTHOPTIONS_DEC] = "Dec";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Other";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Other";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Other";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Other (Free Text)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "None of the above";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "No";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Yes";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "No";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Yes";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "No";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Yes";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "No";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Yes";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Asked unknown";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "No";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Unknown";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Yes";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Yes";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Yes";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "No";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Yes";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Yes";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "No";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Yes";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "No";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Yes";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "No";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Yes";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "No";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Yes";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "No";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Yes";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "No";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Yes";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "No";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Yes";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "No";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Yes";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "No";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Yes";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "No";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Yes";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "No";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Yes";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "No";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Yes";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "No";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Yes";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "No";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Yes";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "No";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Yes";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "No";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Yes";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "No";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Yes";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "No";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Yes";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "No";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Yes";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "No";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "No";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Yes";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "No";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Yes";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "No";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Yes";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "No";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Unknown";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Yes";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "No";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Yes";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "No";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Yes";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "No";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Yes";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "No";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Yes";
translations[OPTION_vaporizerSightGlassOptions_NO] = "No";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Unknown";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Yes";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "No";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Yes";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "No";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Yes";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "No";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Yes";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "No";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Yes";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Yes";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "No";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Yes";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "No";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Yes";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "No";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Yes";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "No";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Yes";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "No";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Unknown";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Yes";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "No";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Yes";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Yes";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "No";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Yes";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "No";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Yes";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "No";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Yes";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "No";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Yes";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Yes";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Yes";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Yes";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Yes";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Yes";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "No";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Yes";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "No";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Yes";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "No";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Yes";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "No";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Yes";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "No";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Yes";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Yes";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "No";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Yes";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "No";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Yes";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "No";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Yes";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "No";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "No";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Yes";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "No";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "No";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Yes";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "No";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Yes";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "No";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Yes";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "No";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Yes";
translations[OPTION_WITHPUMPOPTIONS_NO] = "No";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "No";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Yes";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "No";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "No";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Yes";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "No";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Yes";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "No";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Yes";
translations[OPTION_GELPACKSOPTIONS_NO] = "No";
translations[OPTION_GELPACKSOPTIONS_YES] = "Yes";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "No";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Yes";
translations[OPTION_ALARMOPTIONS_NO] = "No";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "No";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Yes";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "No";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Yes";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "No";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Yes";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "No";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Unknown";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "No";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Yes";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Other (Free Text)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "No";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Yes";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "No";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Yes";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "No";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Yes";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Asked Unknown";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Asked Unknown";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "No";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "None of the above";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "No - describe the color (free text)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Yes - Specify the tool used (Free Text)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Separation";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "None";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Yes - Other (Free Text)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Unknown";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "No";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Kilogram(s)";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "Pound(s)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "No";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Unknown";
translations[PLEASE_ENTER_THE_VALUE] = "Please enter the value";
translations[PLEASE_SELECT_THE_VALUE] = "Please select the value";
translations[PLEASE_SELECT_THE_DATE] = "Please select the date";
translations[PLEASE_CHOOSE_THE_VALUE] = "Please choose the value";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Unknown";

translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "GREAT BRITAIN";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "NORTHERN IRELAND";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGHANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ÅLAND ISLANDS";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBANIA";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ALGERIA";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "AMERICAN SAMOA";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORRA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILLA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTARCTICA";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA AND BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINA";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIA";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRALIA";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "AUSTRIA";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBAIJAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHRAIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BELARUS";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BELGIUM";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDA";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BHUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIVIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOSNIA AND HERZEGOVINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "BOUVET ISLAND";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRAZIL";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "BRITISH INDIAN OCEAN TERRITORY";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BULGARIA";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "CAMBODIA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "CAMEROON";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "CANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "CAPE VERDE";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "CAYMAN ISLANDS";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "CENTRAL AFRICAN REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "CHAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CHINA";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "CHRISTMAS ISLAND";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "COCOS (KEELING) ISLANDS";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "COLOMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "COMOROS";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "CONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "CONGO, THE DEMOCRATIC REPUBLIC OF THE";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "COOK ISLANDS";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "CÔTE D'IVOIRE (IVORY COAST)";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "CROATIA";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "CUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CYPRUS";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "CZECH REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DENMARK";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DJIBOUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINICA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "DOMINICAN REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "ECUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGYPT";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "EQUATORIAL GUINEA";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTONIA";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETHIOPIA";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "FALKLAND ISLANDS (MALVINAS)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "FAROE ISLANDS";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINLAND";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANCE";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "FRENCH GUIANA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "FRENCH POLYNESIA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "FRENCH SOUTHERN TERRITORIES";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABON";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEORGIA";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "GERMANY";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GREECE";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GREENLAND";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRENADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADELOUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINEA";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEA-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUYANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "HEARD ISLAND AND MCDONALD ISLANDS";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "HOLY SEE (VATICAN CITY STATE)";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONG KONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "HUNGARY";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ICELAND";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "INDIA";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONESIA";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN, ISLAMIC REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAQ";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRELAND";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "ISLE OF MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAEL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "ITALY";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAICA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "JAPAN";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDAN";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KAZAKHSTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENYA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "KOREA, REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWAIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KYRGYZSTAN";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "LAO PEOPLE'S DEMOCRATIC REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LATVIA";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LEBANON";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTHO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBYAN ARAB JAMAHIRIYA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITHUANIA";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUXEMBOURG";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASCAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALAYSIA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALDIVES";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "MARSHALL ISLANDS";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINIQUE";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURITANIA";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURITIUS";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAYOTTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MEXICO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "MICRONESIA, FEDERATED STATES OF";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDOVA";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLIA";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MOROCCO";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOZAMBIQUE";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "NETHERLANDS";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NEW CALEDONIA";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NEW ZEALAND";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "NORFOLK ISLAND";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "NORTHERN MARIANA ISLANDS";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NORWAY";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "PALESTINIAN TERRITORY, OCCUPIED";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA NEW GUINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAY";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "PHILIPPINES";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLAND";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTUGAL";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "QATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "ROMANIA";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "RUSSIAN FEDERATION";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RWANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SAINT BARTHÉLEMY";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "SAINT HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SAINT KITTS AND NEVIS";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SAINT LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SAINT MARTIN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAINT PIERRE AND MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAINT VINCENT AND THE GRENADINES";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SAO TOME AND PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "SAUDI ARABIA";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERBIA";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEYCHELLES";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPORE";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "SLOVAKIA";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "SLOVENIA";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "SOLOMON ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "SOUTH AFRICA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "SPAIN";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAME";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD AND JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SWAZILAND";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "SWEDEN";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "SWITZERLAND";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SYRIAN ARAB REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAIWAN, R.O.C.";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TAJIKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZANIA, UNITED REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "THAILAND";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD AND TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNISIA";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "TURKEY";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "TURKS AND CAICOS ISLANDS";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UKRAINE";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "UNITED ARAB EMIRATES";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "UNITED KINGDOM";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "UNITED STATES";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "UNITED STATES MINOR OUTLYING ISLANDS";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAY";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "UZBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIET NAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "VIRGIN ISLANDS, BRITISH";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "VIRGIN ISLANDS, U.S.";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS AND FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "WESTERN SAHARA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "YEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBABWE";

//-------Need to add transition
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "No";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Unknown";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Yes";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "I have read and understand the linked Privacy Notice for the Vantive Product Feedback Portal.";
translations[PRODUCT_LOT] = "Product Lot";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Shipping/Distribution Label";
translations[CARTON_LABEL] = "Carton Label";
translations[INTERNAL_PRODUCT_LABEL] = "Internal Product Label";
translations[TITLE_PD_RENAL] = "PD Renal";
translations[TITLE_SOLUTIONS] = "Solutions";
translations[TITLE_ACCESS] = "Access";
translations[TITLE_ALL_OTHER_PRODUCT] = "All Other Product";
translations[REPORTED_PROBLEM] = "Reported Problem";
translations[LOGIN] = "Login";
translations[SYSTEM_MENU] = "System Menu";
translations[INITIATE_PRODUCT_FEEDBACK] = "Initiate Product Feedback";
translations[FEEDBACK_STATUS] = "Feedback Status";
translations[OKTACALLBACK] = "OktaCallback";
translations[VALID_EMAIL] = "Please enter valid email address";
translations[VALID_NUMERIC] = "Please enter a whole number.";
translations[PLEASE_UPLOAD_IMAGE] = "Please Upload Image(s)";
translations[VALID_DATE] = "Please select a valid date";
translations[QUANTITY] = "Quantity";
translations[EDIT] = "Edit";
translations[DELETE] = "Delete";
translations[LOT_SERIAL_NO] = "Lot /Serial No";

translations[LOT_NUMBER_NOT_FOUND] = "Lot number not found";
translations[SEARCHING_LOT_NUMBER] = "Searching lot number";
translations[PRODUCT_CODE_NOT_FOUND] = "Product code not found";
translations[SEARCHING_PRODUCT_CODE] = "Searching product code";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "File of types (.exe, .scr, .vbs, .js, .xml, .docm, .xps, .iso, .img, .cmd, .bat, .php, .py, .ps1) are not allowed";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "The file you are attempting to attach exceeds the storage limit. Please compress or attach a different file.";
translations[IMAGE_ICON] = "Click on the image icon to select the option";
translations[LOGIN_TO_ACCOUNT] = "Login to Account";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Sign In to your account";
translations[PASSWORD] = "Password";
translations[SIGN_IN] = "Sign In";
translations[UNKNOWN] = "Unknown";
translations[ASKED_UNKNOWN] = "Asked Unknown";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Select Country";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Chinese (Simplified Chinese)";
translations[DUTCH] = "Dutch";
translations[ENGLISH] = "English";
translations[FRENCH] = "French";
translations[GERMAN] = "German";
translations[ITALIAN] = "Italian";
translations[JAPANESE] = "Japanese";
translations[KOREAN] = "Korean";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandarin (Traditional Chinese)";
translations[POLISH] = "Polish";
translations[PORTUGUESE] = "Portuguese";
translations[SPANISH] = "Spanish";
translations[THAI] = "Thai";
translations[TURKISH] = "Turkish";
translations[VIETNAMESE] = "Vietnamese";
translations[BROWSE] = "Browse";
translations[FEEDBACK_SUBMITTED] = "Feedback Submitted";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "Your product experience feedback has been successfully submitted. Thank you for your report. You will receive an email containing a reference number. If additional information is needed to support our investigation, we may reach out to you directly for clarification-especially in cases where the complaint information is incomplete or unclear. If your feedback involves a product sample, we kindly ask that the sample be retained. Our team will coordinate and facilitate the return of the product for a complete and thorough investigation. As a provider of medical products, customer satisfaction and feedback are essential to our goal of delivering the highest quality products. Please contact ";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = " if you have questions or additional information.";
translations[CLOSE] = "Close";
translations[PATIENT_AGE] = "Patient Age";
translations[ENTER_AGE] = "Enter Age";
translations[PATIENT_DOB] = "Patient DOB";
translations[RELEVANT_ATTACHMENTS] = "Please provide any relevant attachments";
translations[VANTIVE_ACCOUNT_CREDENTIALS] = "Enter your Vantive Account credentials";
translations[GET_PRODUCT_DETAILS] = "Get Product Details";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Use the diagram above (figure 2) to determine the location of the reported issue";
translations[FACILITY_ADDRESS] = "Facility Address";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Another Facility Address";
translations[CHOOSE_PRODUCT_CODE] = "Please choose Product Code for the Lot/Serial Number entered";
translations[DECLINE] = "Decline";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT EUSTATIUS AND SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURAÇAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "SOUTH SUDAN";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "indicates help text is available for this field.";

translations[YOUR_FIRST_NAME] = "Your First Name";
translations[YOUR_LAST_NAME] = "Your Last Name";
translations[MY_FIRST_NAME] = "My First Name";
translations[MY_LAST_NAME] = "My Last Name";
translations[PATIENT_FIRST_NAME] = "Patient's First Name";
translations[PATIENT_LAST_NAME] = "Patient's Last Name";
translations[REPORTER_FIRST_NAME] = "Reporter First Name";
translations[REPORTER_LAST_NAME] = "Reporter Last Name";
translations[EMPLOYEE_FIRST_NAME] = "Employee First Name";
translations[EMPLOYEE_LAST_NAME] = "Employee Last Name";
translations[END_USER_CUSTOMER_FIRST_NAME] = "End User/Customer Contact First Name";
translations[END_USER_CUSTOMER_LAST_NAME] = "End User/Customer Contact Last Name";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Additional Contact First Name";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Additional Contact Last Name";

translations[COPYRIGHT] = "Copyright ©";
translations[COPYRIGHT_VANTIVE] = "Vantive";
translations[COPYRIGHT_VERSION] = "All rights reserved | Version";

translations[ADD_ADDITIONAL_CONTACT] = "Add Additional Contact";
translations[CONTACT_ME] = "The customer does not wish to be contacted. Contact me for any additional questions.";
translations[DO_NOT_CONTACT] = "Do Not Contact";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "End User/Customer Facility Name";
translations[END_USER_CUSTOMER_PHONE] = "End User/Customer Facility Phone Number";
translations[END_USER_CUSTOMER_EMAIL] = "End User/Customer Email Address";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "End User/Customer Facility Address";
translations[SAME_AS_PATIENT_ADDRESS] = "Same as Patient Address";

translations[SAME_AS_REPORTER_ADDRESS] = "Same as Reporter Address";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Same as End User/Customer Address";

translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Use the diagram above (figure 3) to determine the location of the reported issue";
translations[CONTACT_US] = "Contact Us";
translations[LANDING_BRIEF_FOR_DEVICE] = "For device repairs, parts, services, or technical support, please contact your local technical service support team.";
translations[PATIENT_SEX] = "Patient Sex";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Cisgender man/boy";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Cisgender woman/girl";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Transgender man/trans man/female-to-male (FTM)";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Transgender woman/trans woman/male-to-female (MTF)";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Other gender category; please specify";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Decline to answer";
translations[ATTENTION_NEEDED] = "!!! URGENT ATTENTION NEEDED: Your Product Feedback Portal submission has FAILED!";
translations[SUBMIT_ERR_MSG] = "To re-submit, please click OK and then Submit Or, email your complaint to (@@@)";
translations[SUBMIT_RETRY_MSG] = "If you re-submitted, please verify you received a confirmation e-mail in your e-mail box from the Product Feedback Portal.  If no confirmation e-mail was received, the submission was not successful, and you MUST email your complaint to (@@@)";
translations[OK] = "OK";

export default lang;
